// ViewerRouteFallback — the Suspense fallback shown only while a lazily-loaded
// viewer route's chunk downloads (first visit / cold cache).
//
// Why it exists (#261): EditorView/ShareView/FilesView are loaded via
// `lazyWithRetry` so the three.js viewer chunk stays off the landing critical
// path. While that chunk streams in, the route needs a fallback. On desktop the
// chunk is idle-prefetched (see main.tsx) so this is effectively never seen; on
// the editor route over a warm connection the flash is sub-frame. It fills its
// parent (h-full) and reserves a min height so it never causes layout shift, and
// matches the app's existing loader styling.
//
// Lives in its own file (not main.tsx) so the entry module stays component-free
// — keeps Fast Refresh happy and the route fallback reusable. Load-path only: no
// per-frame work, no WebGL — zero effect on the viewer/RTX render loop.
import { Loader2 } from '@/components/ui/icons';

export function ViewerRouteFallback() {
  return (
    <div className="flex h-full min-h-[60vh] w-full items-center justify-center bg-telekinesis-bg-secondary-dark text-telekinesis-text-primary">
      <Loader2 className="h-8 w-8 animate-spin" />
    </div>
  );
}
